import { useState } from 'react'
import { Filter } from './types'
import { useFilters } from './hooks/use-filters'
import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover'
import { Text } from '$components'
import { Options } from './options/options'

export function FilterItem({ filter }: { filter: Filter }) {
  const [isOpen, setOpen] = useState(false)
  const { getFilter } = useFilters()

  return (
    <Popover
      open={isOpen}
      onOpenChange={setOpen}
    >
      <PopoverTrigger asChild>
        <button className="w-full px-3 py-2 focus:outline-none hover:bg-gray-50/50 flex items-center gap-2 cursor-pointer">
          {filter.icon && (
            <div className="flex-shrink-0">
              <filter.icon className="size-4 text-gray-500" />
            </div>
          )}

          <Text type="s">
            {filter.label}
          </Text>

          {getFilter(filter) && (
            <div className="size-2 ml-auto rounded-full bg-indigo-400" />
          )}
        </button>
      </PopoverTrigger>

      <PopoverContent
        side="right"
        align="start"
        sideOffset={2}
        collisionPadding={16}
        className="text-sm w-full min-w-[12rem] py-1.5 border border-gray-100 z-50 rounded-xl bg-white shadow-xl"
      >
        <Options filters={[filter]} />
      </PopoverContent>
    </Popover>
  )
}
